// @flow
import React from 'react';
import { connect } from 'react-redux';
import Scroll from 'react-scroll';
import moment from 'moment';
import _ from 'lodash';
import Actions from '../../actions/Creators';
import {
    Layout,
    ToggleButton,
    Loader,
    Button,
    EmptyResults,
    Pagination,
    Icon,
    SearchString,
} from '../../components/common/';
import ProductTable from '../../components/products/productTable/ProductTable';
import OfferDetails from '../../components/products/offerDetails/OfferDetails';
import ImportProducts from '../../components/products/importProducts/ImportProducts';
import Modal from '../../components/common/modal/Modal';
import Dropdown from '../../components/common/filterDropdown/Dropdown';
import LocaleLink from '../../components/common/LocaleLink';
import OfferSearch from '../../components/products/offerSearch/OfferSearch';
import I18n from '../../i18n/I18n';
import Helper from '../../helper/Helper';
import ExportList from '../../components/products/exportList/ExportList';
import styles from './Products.scss';

class Products extends React.Component {
    constructor() {
        super();

        this.state = {
            currentPage: 1,
            businessModel: 4,
            itemPerPage: 20,
            statusFilter: '2',
            actionBox: false,
            selectedOffers: [],
            key: '',
            dir: '',
            modalOpen: false,
            pSkuOpen: false,
            importError: '',
            importSuccess: '',
            search: '',
            dialogOpen: false,
            view: 'grid',
            export: 'offers',
        };

        this.onOfferSelect = this.onOfferSelect.bind(this);
        this.onBack = this.onBack.bind(this);
        this.searchProductsData = this.searchProductsData.bind(this);
        this.toggleBusiness = this.toggleBusiness.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.perPage = this.perPage.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.sortColumn = this.sortColumn.bind(this);
        this.openModal = this.openModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.importOffers = this.importOffers.bind(this);
        // this.onSearch = this.onSearch.bind(this);
    }
    componentDidMount() {
        if (this.props.user && this.props.seller) {
            if (this.props.match.params.offerCode) {
                this.getProductByOfferCode(this.props.match.params.offerCode);
            } else if (this.props.match.params.key === 'search') {
                this.searchProductsData('');
            } else if (this.props.match.params.sku) {
                this.getProductBySKU(this.props.match.params.sku);
            } else
                this.getProductsData(
                    this.state.itemPerPage,
                    this.state.currentPage,
                    this.state.businessModel,
                    this.state.statusFilter,
                    this.state.key,
                    this.state.dir,
                    this.state.search,
                );
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.match !== nextProps.match ||
            this.props.seller !== nextProps.seller
        ) {
            if (nextProps.match.params.offerCode) {
                this.getProductByOfferCode(nextProps.match.params.offerCode);
            } else if (nextProps.match.params.key === 'search') {
                this.searchProductsData('');
            } else if (nextProps.match.params.sku) {
                this.getProductBySKU(nextProps.match.params.sku);
            } else
                this.getProductsData(
                    this.state.itemPerPage,
                    this.state.currentPage,
                    this.state.businessModel,
                    this.state.statusFilter,
                    this.state.key,
                    this.state.dir,
                    this.state.search,
                );
        }
        if (
            this.props.isImportLoading !== nextProps.isImportLoading &&
            nextProps.isImportCompleted
        ) {
            this.setState({
                importError:
                    nextProps.isImportCompleted && nextProps.error
                        ? nextProps.error
                        : '',
                importSuccess:
                    nextProps.isImportCompleted && nextProps.success
                        ? nextProps.success
                        : '',
            });
        }
    }

    getProductsData(limits, page, businessModel, isActive, key, dir, search) {
        this.setState({
            currentPage: page,
        });
        const isFbn = businessModel === 3;
        let query = `?limits=${limits}&page=${page}`;
        query = isFbn ? `${query}&is_fbn=1` : query;
        query =
            isActive && isActive !== '2'
                ? `${query}&is_active=${isActive}`
                : query;
        query = key ? `${query}&sort=${key}` : query;
        query = key && dir ? `${query}&dir=${dir}` : query;
        query = search ? `${query}&search=${search}` : query;
        this.props.dispatch(Actions.getProducts(query));
    }
    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    openPSkuModal() {
        this.setState({
            pSkuOpen: true,
        });
    }

    onCloseModal() {
        this.setState({
            modalOpen: false,
            importError: '',
            importSuccess: '',
        });
    }
    onClosePSkuModal() {
        this.setState({
            pSkuOpen: false,
            importError: '',
            importSuccess: '',
        });
    }
    openDialog = () => {
        this.setState({
            dialogOpen: true,
        });
    };

    closeDialog = () => {
        this.setState({
            dialogOpen: false,
        });
    };
    searchProductsData(query) {
        Scroll.animateScroll.scrollToTop({ delay: 0 });
        const params = {
            query: query,
            facets: ['category', 'is_active'],
            facetFilters: ['is_active:1'],
        };
        this.props.dispatch(Actions.searchProducts(params));
    }

    toggleBusiness = businessModel => {
        this.getProductsData(
            this.state.itemPerPage,
            1,
            businessModel === 2 ? 3 : 4,
            this.state.statusFilter,
            this.state.key,
            this.state.dir,
            this.state.search,
        );
        this.setState({
            businessModel: businessModel === 2 ? 3 : 4,
            currentPage: 1,
            selectedOffers: [],
            actionBox: false,
        });
    };

    getProductByOfferCode(offerCode) {
        Scroll.animateScroll.scrollToTop({ delay: 0 });
        const query = `/details?offer_code=${offerCode}`;
        this.props.dispatch(Actions.getProducts(query));
    }

    onPageChange = page => {
        var newState = {};
        newState['currentPage'] = page.selected + 1;
        this.setState(newState);
        this.getProductsData(
            this.state.itemPerPage,
            page.selected + 1,
            this.state.businessModel,
            this.state.statusFilter,
            this.state.key,
            this.state.dir,
            this.state.search,
        );
    };

    onSearch = search => {
        if (this.props.match.params.offerCode) {
            this.props.history.push(`/${Helper.getLocale()}/products/`);
        }
        this.getProductsData(
            this.state.itemPerPage,
            1,
            this.state.businessModel,
            null,
            null,
            null,
            search,
        );
        var newState = {};
        newState['currentPage'] = 1;
        newState['search'] = search;
        this.setState(newState);
    };

    getProductBySKU(sku) {
        Scroll.animateScroll.scrollToTop({ delay: 0 });
        const query = `/details?sku=${sku}`;
        this.props.dispatch(Actions.getProducts(query));
    }

    clearSearch = () => {
        this.onSearch('');
    };

    onOfferSelect(pskuCanonical) {
        this.props.history.push(
            `${Helper.getAppDomain(
                'catalog',
            )}/${Helper.getLocale()}/catalog/${pskuCanonical}`,
        );
        // this.getProductByOfferCode(offerCode);
    }

    onBack() {
        this.props.history.push(`/${Helper.getLocale()}/products/`);
        this.getProductsData(
            this.state.itemPerPage,
            1,
            this.state.businessModel,
            this.state.statusFilter,
            this.state.key,
            this.state.dir,
            this.state.search,
        );
    }

    onSubmit(offer) {
        const updatedOffers = {
            offers: offer,
        };
        this.props.dispatch(Actions.postProducts(updatedOffers));
    }

    toggleCheckbox(id) {
        let selectedOffers = this.state.selectedOffers;
        if (selectedOffers) {
            if (selectedOffers.includes(id)) {
                _.remove(selectedOffers, offerId => {
                    return offerId === id;
                });
            } else {
                selectedOffers.push(id);
            }
        }
        var newState = {};
        newState['selectedOffers'] = selectedOffers;
        newState['actionBox'] = !_.isEmpty(selectedOffers);
        this.setState(newState);
    }

    selectAll() {
        const offers =
            this.props.products &&
            this.props.products.products &&
            this.props.products.products.offers
                ? this.props.products.products.offers
                : [];
        let selectedOffers = this.state.selectedOffers;
        if (
            selectedOffers &&
            offers &&
            !_.isEmpty(offers) &&
            selectedOffers.length < offers.length
        ) {
            selectedOffers = [];
            for (let i = 0; i < offers.length; i++) {
                selectedOffers.push(offers[i].id_offer);
            }
        } else {
            selectedOffers = [];
        }

        var newState = {};
        newState['selectedOffers'] = selectedOffers;
        newState['actionBox'] = !_.isEmpty(selectedOffers);
        this.setState(newState);
    }

    export(all) {
        let selectedOffers = this.state.selectedOffers;
        let exportOffers = {
            business_model: this.state.businessModel,
            id_offers: selectedOffers,
            is_active:
                this.state.statusFilter && this.state.statusFilter !== '2'
                    ? this.state.statusFilter
                    : null,
        };

        exportOffers = all ? _.omit(exportOffers, ['id_offers']) : exportOffers;
        exportOffers =
            !all || exportOffers.is_active === null
                ? _.omit(exportOffers, ['is_active'])
                : exportOffers;

        this.props.dispatch(Actions.exportOffers(exportOffers));
    }

    importOffers(file) {
        this.props.dispatch(Actions.importOffers(file));
    }

    exportPSku = () => {
        this.props.dispatch(Actions.exportPSku());
    };

    exportStock = () => {
        this.props.dispatch(Actions.exportStock());
    };

    importPSkuUnique = file => {
        this.props.dispatch(Actions.importPSkuUnique(file));
    };

    activate(active) {
        let selectedOffers = this.state.selectedOffers;
        let activateOffers = {
            business_model: this.state.businessModel,
            id_offers: selectedOffers,
            limits: this.state.itemPerPage,
            page: this.state.currentPage,
            is_active:
                this.state.statusFilter && this.state.statusFilter !== '2'
                    ? this.state.statusFilter
                    : null,
            // "search"
            activate: active,
        };
        activateOffers =
            activateOffers.is_active === null
                ? _.omit(activateOffers, ['is_active'])
                : activateOffers;
        this.props.dispatch(Actions.activateOffers(activateOffers));
        if (this.state.statusFilter !== '2') {
            this.setState({
                selectedOffers: [],
            });
        }
    }

    onDelete() {
        let selectedOffers = this.state.selectedOffers;
        let deleteOffers = {
            business_model: this.state.businessModel,
            id_offers: selectedOffers,
            limits: this.state.itemPerPage,
            page: this.state.currentPage,
            is_active:
                this.state.statusFilter && this.state.statusFilter !== '2'
                    ? this.state.statusFilter
                    : null,
            // "search"
        };
        deleteOffers =
            deleteOffers.is_active === null
                ? _.omit(deleteOffers, ['is_active'])
                : deleteOffers;
        this.closeDialog();
        this.props.dispatch(Actions.deleteOffers(deleteOffers));
        this.setState({
            selectedOffers: [],
        });
    }

    statusChange(e) {
        var newState = {};
        newState['statusFilter'] = e;
        newState['currentPage'] = 1;
        newState['actionBox'] = false;
        newState['selectedOffers'] = [];
        this.setState(newState);
        if (e.value !== '2') {
            this.getProductsData(
                this.state.itemPerPage,
                1,
                this.state.businessModel,
                e,
                this.state.key,
                this.state.dir,
                this.state.search,
            );
        } else {
            this.getProductsData(
                this.state.itemPerPage,
                1,
                this.state.businessModel,
                null,
                this.state.statusFilter,
                this.state.key,
                this.state.dir,
                this.state.search,
            );
        }
    }

    viewChange = e => {
        const newState = {};
        console.log(e, 'EVENT');
        newState.view = e;
        this.setState(newState);
    };

    perPage(e) {
        var newState = {};
        newState['itemPerPage'] = e;
        newState['currentPage'] = 1;
        this.setState(newState);
        this.getProductsData(
            e,
            1,
            this.state.businessModel,
            this.state.statusFilter,
            this.state.key,
            this.state.dir,
            this.state.search,
        );
    }

    sortColumn(key, dir) {
        var newState = {};
        newState['key'] = key;
        newState['dir'] = dir;
        newState['currentPage'] = 1;
        this.setState(newState);
        this.getProductsData(
            this.state.itemPerPage,
            1,
            this.state.businessModel,
            this.state.statusFilter,
            key,
            dir,
        );
    }

    render() {
        const { products, seller, user, count } = this.props;
        const offerCode = this.props.match.params.offerCode || null;
        const sku = this.props.match.params.sku || null;
        const key = this.props.match.params.key || null;

        let title = 'products.title';
        if (sku || offerCode) {
            title = 'products.offer-details-title';
            // if (
            //   products &&
            //   products.products &&
            //   products.products.offers &&
            //   !_.isEmpty(products.products.offers)
            // ) {
            //   title = products.products.offers[0].title;
            // }
        } else if (key && key === 'search') {
            title = 'products.list-offer-title';
        }

        const viewOptions = [
            {
                value: 'grid',
                key: 'grid',
                label: <Icon name="table" className={styles.viewIconTable} />,
            },
            {
                value: 'box',
                key: 'box',
                label: <Icon name="list-view" className={styles.viewIcon} />,
            },
        ];

        const statusOptions =
            products && products.products && products.products.offers
                ? [
                      {
                          value: '2',
                          key: '2',
                          label: I18n.getText(
                              'products.status-all',
                              {
                                  count:
                                      count && count.counts
                                          ? count.counts.active +
                                            count.counts.inactive
                                          : 0,
                              },
                              'All ({count})',
                          ),
                      },
                      {
                          value: '1',
                          key: '1',
                          label: I18n.getText(
                              'products.status-active',
                              {
                                  count:
                                      count && count.counts
                                          ? count.counts.active
                                          : 0,
                              },
                              'Active ({count})',
                          ),
                      },
                      {
                          value: '0',
                          key: '0',
                          label: I18n.getText(
                              'products.status-inactive',
                              {
                                  count:
                                      count && count.counts
                                          ? count.counts.inactive
                                          : 0,
                              },
                              'Inactive ({count})',
                          ),
                      },
                  ]
                : [];

        const pageOptions =
            products && products.products && products.products.offers
                ? [
                      {
                          value: 20,
                          key: 20,
                          label: I18n.getText(
                              'products.20-per-page',
                              {},
                              '20 Per Page',
                          ),
                      },
                      {
                          value: 40,
                          key: 40,
                          label: I18n.getText(
                              'products.40-per-page',
                              {},
                              '40 Per Page',
                          ),
                      },
                      {
                          value: 60,
                          key: 60,
                          label: I18n.getText(
                              'products.60-per-page',
                              {},
                              '60 Per Page',
                          ),
                      },
                  ]
                : [];

        return (
            <Layout
                currentIndex={3}
                title={title}
                onSearch={
                    !offerCode && !sku && key !== 'search' ? this.onSearch : ''
                }
                search={this.state.search}
                searchLabel={
                    !offerCode && !sku && key !== 'search'
                        ? 'products.top-search-placeholder'
                        : ''
                }
            >
                {this.props.isLoading ? (
                    <div>
                        <Loader />
                    </div>
                ) : (
                    <div>
                        {seller ? (
                            <div className={styles.ctr}>
                                {offerCode || sku ? (
                                    <div>
                                        {products &&
                                        products.products &&
                                        products.products.offers &&
                                        !_.isEmpty(products.products.offers) ? (
                                            <OfferDetails
                                                data={products.products.offers}
                                                currencyCode={
                                                    seller.selected_currency
                                                }
                                                countryCode={
                                                    seller.country_code
                                                }
                                                onBack={this.onBack}
                                                seller={seller}
                                                browser={this.props.browser}
                                                onSubmit={this.onSubmit}
                                                history={this.props.history}
                                                lang={this.props.lang}
                                                bySku={Boolean(sku)}
                                            />
                                        ) : (
                                            <EmptyResults
                                                type="product"
                                                handleBtnClick={this.onBack}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        {key === 'search' ? (
                                            <div>
                                                {products &&
                                                products.products ? (
                                                    <OfferSearch
                                                        searchProductsData={
                                                            this
                                                                .searchProductsData
                                                        }
                                                        data={products.products}
                                                        isSearchLoading={
                                                            this.props
                                                                .isSearchLoading
                                                        }
                                                        history={
                                                            this.props.history
                                                        }
                                                    />
                                                ) : (
                                                    <EmptyResults type="products" />
                                                )}
                                            </div>
                                        ) : (
                                            <div>
                                                <div
                                                    className={
                                                        styles.btnWrapper
                                                    }
                                                >
                                                    <ToggleButton
                                                        toggleBtn={
                                                            this.toggleBusiness
                                                        }
                                                        toggleItems={[
                                                            I18n.getText(
                                                                'transfers.crossdock-b2b',
                                                            ),
                                                            I18n.getText(
                                                                'products.noon-now',
                                                            ),
                                                        ]}
                                                        selected={
                                                            this.state
                                                                .businessModel ===
                                                            3
                                                                ? 2
                                                                : 1
                                                        }
                                                    />
                                                    <div
                                                        className={
                                                            styles.btnContainer
                                                        }
                                                    >
                                                        {products &&
                                                        products.products &&
                                                        products.products
                                                            .offers &&
                                                        !_.isEmpty(
                                                            products.products
                                                                .offers,
                                                        ) ? (
                                                            <ExportList
                                                                exportStock={
                                                                    this
                                                                        .exportStock
                                                                }
                                                                exportOffer={() =>
                                                                    this.export(
                                                                        1,
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                        <Button
                                                            className={
                                                                styles.flexer
                                                            }
                                                            variant="transparent"
                                                            onClick={() =>
                                                                this.openModal()
                                                            }
                                                        >
                                                            <Icon
                                                                name="stack"
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />

                                                            {I18n.getText(
                                                                'products.import-offers',
                                                                {},
                                                                'Import Multiple Offers',
                                                            )}
                                                        </Button>
                                                        <LocaleLink
                                                            to="/products/search"
                                                            className={
                                                                styles.flexer
                                                            }
                                                        >
                                                            <Button
                                                                className={
                                                                    styles.flexer
                                                                }
                                                            >
                                                                <Icon
                                                                    name="list"
                                                                    className={
                                                                        styles.icon
                                                                    }
                                                                />
                                                                {I18n.getText(
                                                                    'products.list-an-offer',
                                                                    {},
                                                                    'List an Offer',
                                                                )}
                                                            </Button>
                                                        </LocaleLink>
                                                    </div>
                                                </div>
                                                {
                                                    <div
                                                        className={
                                                            styles.subWrapper
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles.filterWrapper
                                                            }
                                                        >
                                                            <div
                                                                className={`${
                                                                    styles.eachFilter
                                                                } ${
                                                                    styles.viewFilter
                                                                }`}
                                                            >
                                                                <Dropdown
                                                                    onChange={
                                                                        this
                                                                            .viewChange
                                                                    }
                                                                    selected={
                                                                        this
                                                                            .state
                                                                            .view
                                                                    }
                                                                    options={
                                                                        viewOptions
                                                                    }
                                                                    label={I18n.getText(
                                                                        'filter.view',
                                                                    )}
                                                                />
                                                            </div>
                                                            <div
                                                                className={
                                                                    styles.eachFilter
                                                                }
                                                            >
                                                                <Dropdown
                                                                    onChange={
                                                                        this
                                                                            .statusChange
                                                                    }
                                                                    selected={
                                                                        this
                                                                            .state
                                                                            .statusFilter
                                                                    }
                                                                    options={
                                                                        statusOptions
                                                                    }
                                                                    label={I18n.getText(
                                                                        'products.status',
                                                                        {},
                                                                        'Offer Status',
                                                                    )}
                                                                />
                                                            </div>
                                                            <div
                                                                className={
                                                                    styles.eachFilter
                                                                }
                                                            >
                                                                <Dropdown
                                                                    onChange={
                                                                        this
                                                                            .perPage
                                                                    }
                                                                    selected={
                                                                        this
                                                                            .state
                                                                            .itemPerPage
                                                                    }
                                                                    options={
                                                                        pageOptions
                                                                    }
                                                                    label={I18n.getText(
                                                                        'products.display',
                                                                        {},
                                                                        'Display',
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={
                                                                styles.searchCtr
                                                            }
                                                        >
                                                            {this.state
                                                                .search ? (
                                                                <SearchString
                                                                    search={
                                                                        this
                                                                            .state
                                                                            .search
                                                                    }
                                                                    clearSearch={
                                                                        this
                                                                            .clearSearch
                                                                    }
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                {!_.isEmpty(
                                                    this.state.selectedOffers,
                                                ) ? (
                                                    <div
                                                        className={
                                                            styles.actionBox
                                                        }
                                                    >
                                                        <Button
                                                            className={
                                                                styles.flexer
                                                            }
                                                            variant="transparent"
                                                            onClick={() =>
                                                                this.export()
                                                            }
                                                        >
                                                            <Icon
                                                                name="download"
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />
                                                            {this.props
                                                                .isExportLoading ? (
                                                                <div
                                                                    className={
                                                                        styles.loader
                                                                    }
                                                                />
                                                            ) : (
                                                                I18n.getText(
                                                                    'products.export-selected',
                                                                    {},
                                                                    'Export Selected',
                                                                )
                                                            )}
                                                        </Button>
                                                        <Button
                                                            className={
                                                                styles.flexer
                                                            }
                                                            variant="transparent"
                                                            onClick={() =>
                                                                this.activate(1)
                                                            }
                                                        >
                                                            <Icon
                                                                name="tick"
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />
                                                            {I18n.getText(
                                                                'products.activate',
                                                                {},
                                                                'Activate Products',
                                                            )}
                                                        </Button>
                                                        <Button
                                                            className={
                                                                styles.flexer
                                                            }
                                                            variant="transparent"
                                                            onClick={() =>
                                                                this.activate(0)
                                                            }
                                                        >
                                                            <Icon
                                                                name="close"
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />

                                                            {I18n.getText(
                                                                'products.deactivate',
                                                                {},
                                                                'Deactivate Products',
                                                            )}
                                                        </Button>
                                                        <Button
                                                            className={
                                                                styles.flexer
                                                            }
                                                            variant="transparent"
                                                            onClick={() =>
                                                                this.openDialog()
                                                            }
                                                        >
                                                            <Icon
                                                                name="trash"
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />

                                                            {I18n.getText(
                                                                'products.delete',
                                                                {},
                                                                'Delete Products',
                                                            )}
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {products &&
                                                products.products &&
                                                products.products.offers &&
                                                Array.isArray(
                                                    products.products.offers,
                                                ) &&
                                                !_.isEmpty(
                                                    products.products.offers,
                                                ) ? (
                                                    <div
                                                        className={
                                                            styles.productTableWrapper
                                                        }
                                                    >
                                                        {this.props
                                                            .isListLoading ? (
                                                            <div
                                                                className={
                                                                    styles.productTableOverlay
                                                                }
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                        <ProductTable
                                                            data={
                                                                products
                                                                    .products
                                                                    .offers
                                                            }
                                                            currencyCode={
                                                                seller.selected_currency
                                                            }
                                                            lang={
                                                                this.props.lang
                                                            }
                                                            history={
                                                                this.props
                                                                    .history
                                                            }
                                                            browser={
                                                                this.props
                                                                    .browser
                                                            }
                                                            view={
                                                                this.state.view
                                                            }
                                                            searchString={
                                                                this.state
                                                                    .search
                                                            }
                                                            onOfferSelect={
                                                                this
                                                                    .onOfferSelect
                                                            }
                                                            selectedOffers={
                                                                this.state
                                                                    .selectedOffers
                                                            }
                                                            keyVal={
                                                                this.state.key
                                                            }
                                                            dir={this.state.dir}
                                                            sortColumn={
                                                                this.sortColumn
                                                            }
                                                            toggleCheckbox={
                                                                this
                                                                    .toggleCheckbox
                                                            }
                                                            indeterminate={
                                                                this.state
                                                                    .selectedOffers &&
                                                                !_.isEmpty(
                                                                    this.state
                                                                        .selectedOffers,
                                                                ) &&
                                                                this.state
                                                                    .selectedOffers
                                                                    .length !==
                                                                    products
                                                                        .products
                                                                        .offers
                                                                        .length
                                                            }
                                                            selectAll={
                                                                this.selectAll
                                                            }
                                                            allSelected={
                                                                this.state
                                                                    .selectedOffers
                                                                    .length ===
                                                                products
                                                                    .products
                                                                    .offers
                                                                    .length
                                                            }
                                                        />
                                                        {products.products
                                                            .no_of_pages &&
                                                        products.products
                                                            .no_of_pages > 1 ? (
                                                            <div
                                                                className={
                                                                    styles.paginationWrapper
                                                                }
                                                            >
                                                                <Pagination
                                                                    pageCount={Number(
                                                                        products
                                                                            .products
                                                                            .no_of_pages,
                                                                    )}
                                                                    currentPage={
                                                                        this
                                                                            .state
                                                                            .currentPage
                                                                    }
                                                                    onPageChange={
                                                                        this
                                                                            .onPageChange
                                                                    }
                                                                    browser={
                                                                        this
                                                                            .props
                                                                            .browser
                                                                    }
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                ) : (
                                                    <EmptyResults type="products" />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                )}
                <Modal
                    contentLabel={'ProductImport'}
                    isOpen={this.state.modalOpen || this.state.pSkuOpen}
                    closeModal={
                        this.state.pSkuOpen
                            ? () => this.onClosePSkuModal()
                            : () => this.onCloseModal()
                    }
                >
                    <ImportProducts
                        exportPSku={this.exportPSku}
                        importOffers={
                            this.state.pSkuOpen
                                ? this.importPSkuUnique
                                : this.importOffers
                        }
                        isLoading={this.props.isImportLoading}
                        status={this.props.offers}
                        closeModal={
                            this.state.pSkuOpen
                                ? () => this.onClosePSkuModal()
                                : () => this.onCloseModal()
                        }
                        pSkuOpen={this.state.pSkuOpen}
                        success={
                            this.props.isImportCompleted && this.props.success
                                ? this.props.success
                                : ''
                        }
                        error={this.state.importError}
                        success={this.state.importSuccess}
                        text
                    />
                </Modal>
                <Modal
                    contentLabel={'deleteConfirm'}
                    isOpen={this.state.dialogOpen}
                    closeModal={() => this.closeDialog()}
                    dialogBox
                    warning
                    onSubmit={() => this.onDelete()}
                    cancelBtnLabel={I18n.getText('product.cancel-btn')}
                    submitBtnLabel={I18n.getText('product.confirm-btn')}
                    dialogTitle={I18n.getText('product.delete-offers')}
                >
                    <div className={styles.confirmDelete}>
                        {' '}
                        {I18n.getText('product.delete-confirm')}
                    </div>
                </Modal>
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        sessionIsLoading: state.session.isLoading,
        session: state.session,
        lang: state.locale.lang,
        user: state.session.user,
        products: state.products,
        count: state.products.count,
        isLoading: state.products.isLoading,
        isSearchLoading: state.products.isSearchLoading,
        isExportLoading: state.products.isExportLoading,
        isExportAllLoading: state.products.isExportAllLoading,
        isImportLoading: state.products.isImportLoading,
        isListLoading: state.products.isListLoading,
        offers: state.products.offers,
        seller: state.session.seller,
        browser: state.browser,
        success: state.products.successMessage,
        error: state.products.errorMessage,
        isImportCompleted: state.products.isImportCompleted,
    };
};

export default connect(mapStateToProps)(Products);



// WEBPACK FOOTER //
// ./src/containers/products/Products.js